var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-landing"},[(_vm.settings.landing_image)?_c('img',{attrs:{"src":_vm.settings.landing_image}}):_vm._e(),_vm._v(" "),(_vm.landingVideo)?_c('CommonVideo',{attrs:{"src":_vm.landingVideo}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }